import { useEffect } from "react";
import { useOptionalTabContext } from "@/contexts/TabContext";

/**
 * Update the current tab's label dynamically once data loads.
 * Usage: useTabLabel(project?.name ? `Project: ${project.name}` : undefined);
 */
export function useTabLabel(label: string | undefined) {
  const ctx = useOptionalTabContext();
  useEffect(() => {
    if (ctx?.activeTabId && label) {
      ctx.updateTabLabel(ctx.activeTabId, label);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [label]);
}
